import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeENUS from '@angular/common/locales/en';
import localeENGB from '@angular/common/locales/en-GB';

import { CurrencyPipe } from './shared/currency';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SectionNavComponent } from './shared/section-nav/section-nav.component';
import { BrandLogoComponent } from './shared/brand-logo/brand-logo.component';
import { PortalButtonComponent } from './shared/portal-button/portal-button.component';
import { PortalProgressBarComponent } from './shared/portal-progress-bar/portal-progress-bar.component';
import { LocalizedDatePipe } from './shared/localized-date.pipe';
import { PortalPreviewBannerComponent } from './shared/portal-preview-banner/portal-preview-banner.component';
import { PortalPreviewService } from './portal-preview.service';

// Locales used by org date_locale (mirrors the staff app); en-GB is the default.
registerLocaleData(localeENUS);
registerLocaleData(localeENGB);
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { PortalHeaderComponent } from './shared/portal-header/portal-header.component';
import { EditProfileComponent } from './shared/edit-profile/edit-profile.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { PortalModalComponent } from './shared/portal-modal/portal-modal.component';
import { ToBeConfirmedModalComponent } from './shared/to-be-confirmed-modal/to-be-confirmed-modal.component';
import { RejectModalComponent } from './shared/reject-modal/reject-modal.component';
import { ChangeOrderDetailsModalComponent } from './shared/change-order-details-modal/change-order-details-modal.component';
import { TermsModalComponent } from './shared/terms-modal/terms-modal.component';
import { PrivacyModalComponent } from './shared/privacy-modal/privacy-modal.component';
import { ProjectTotalsComponent } from './shared/project-totals/project-totals.component';
import { ProjectFooterComponent } from './shared/project-footer/project-footer.component';
import { LoginComponent } from './login/login/login.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProjectComponent } from './project/project/project.component';
import { QuotesComponent } from './project/quotes/quotes.component';
import { InvoicesComponent } from './project/invoices/invoices.component';
import { ChangeOrdersComponent } from './project/change-orders/change-orders.component';
import { SalesOrdersComponent } from './project/sales-orders/sales-orders.component';
import { ProgressComponent } from './project/progress/progress.component';
import { DocumentsComponent } from './project/documents/documents.component';
import { DocumentComponent } from './project/document/document.component';

@NgModule({
	declarations: [
		AppComponent,
		SectionNavComponent,
		BrandLogoComponent,
		PortalButtonComponent,
		PortalProgressBarComponent,
		PortalPreviewBannerComponent,
		NotificationsComponent,
		PortalHeaderComponent,
		EditProfileComponent,
		LoaderComponent,
		PortalModalComponent,
		ToBeConfirmedModalComponent,
		RejectModalComponent,
		ChangeOrderDetailsModalComponent,
		TermsModalComponent,
		PrivacyModalComponent,
		ProjectTotalsComponent,
		ProjectFooterComponent,
		LoginComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
		AcceptInviteComponent,
		DashboardComponent,
		ProjectComponent,
		QuotesComponent,
		InvoicesComponent,
		ChangeOrdersComponent,
		SalesOrdersComponent,
		ProgressComponent,
		DocumentsComponent,
		DocumentComponent,
		LocalizedDatePipe,
		CurrencyPipe
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpClientModule,
		AppRoutingModule
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'en-GB' },
		// A staff preview has to have its token before the router's first navigation, or the auth
		// guard asks for the session too early, sees no user, and redirects to the login page.
		{
			provide: APP_INITIALIZER,
			useFactory: (preview: PortalPreviewService) => () => preview.bootstrap(),
			deps: [PortalPreviewService],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
